import { useLdFlag } from '@renderer/chat/hooks/useLdFlag'

type HoverButtonsPosition = 'bottom-right' | 'top-right'

const HOVER_BUTTONS_POSITION_FLAG_KEY = 'sidepanel-hover-buttons-position'

/**
 * Which cell corner the hover cluster hangs off. Defaults to the shipped
 * bottom-right, and any unrecognized variation normalizes to it so a dashboard
 * typo can't leave the cluster unpositioned.
 */
export function useHoverButtonsPosition(): HoverButtonsPosition {
  const value = useLdFlag<string>(HOVER_BUTTONS_POSITION_FLAG_KEY, 'bottom-right')
  return value === 'top-right' ? 'top-right' : 'bottom-right'
}
